import * as React from 'react';

function SvgHeartFilled(props) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.62704 2.77852C11.2811 2.76038 12.6372 4.08561 12.6571 5.73967L12.6572 5.74355C12.6578 6.42148 12.4221 7.07843 11.9816 7.6117L7.76046 12.3361C7.62134 12.4918 7.37772 12.4918 7.23855 12.3361C7.10661 12.1886 7.10661 12.1886 6.57889 11.5983C6.08416 11.0449 5.58942 10.4914 5.12766 9.9748C3.7931 8.48163 3.03857 7.63687 3.00837 7.60129C2.57685 7.07843 2.34112 6.42148 2.3418 5.73967C2.36173 4.08561 3.71782 2.76038 5.36683 2.7785C6.16846 2.77569 6.93278 3.08903 7.49946 3.64064C8.06604 3.08903 8.82972 2.7757 9.62704 2.77852Z" />
    </svg>
  );
}

export default SvgHeartFilled;
